import { useState, FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight, Briefcase } from 'lucide-react';
import { GGJLogoMark } from '@shared/components/Brand/GGJLogo';

/** §8.14 — resolve employer career page by organisation slug (URL-safe id from Settings / org record). */
export function CareersLandingPage() {
  const navigate = useNavigate();
  const [slug, setSlug] = useState('');

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    const s = slug.trim().toLowerCase().replace(/[^a-z0-9-]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
    if (s.length < 2) return;
    navigate(`/careers/${encodeURIComponent(s)}`);
  };

  return (
    <div className="min-h-[100dvh] flex flex-col bg-gray-950 text-gray-100">
      <header className="border-b border-gray-800/80 px-4 py-4 sm:px-8">
        <div className="max-w-lg mx-auto flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <GGJLogoMark size={36} className="shrink-0" />
            <div>
              <p className="text-sm font-semibold text-white tracking-tight">Careers</p>
              <p className="text-[11px] text-gray-500">Find your employer&apos;s open roles</p>
            </div>
          </div>
          <Link to="/" className="text-xs text-brand-400 hover:text-brand-300 font-medium whitespace-nowrap">
            Recruiter sign in →
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <div className="flex justify-center mb-6">
            <Briefcase className="w-14 h-14 text-brand-500/80" />
          </div>
          <h1 className="text-xl font-semibold text-white text-center mb-2">Open roles by company</h1>
          <p className="text-sm text-gray-400 text-center mb-8 leading-relaxed">
            Enter the <strong className="text-gray-300">career slug</strong> your recruiter shared (same value as the organisation URL slug in GoGrabJob).
          </p>
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label htmlFor="org-slug" className="block text-xs text-gray-500 mb-1.5">
                Organisation slug
              </label>
              <input
                id="org-slug"
                type="text"
                autoComplete="organization"
                placeholder="e.g. acme-talent"
                value={slug}
                onChange={(e) => setSlug(e.target.value)}
                className="w-full rounded-lg border border-gray-700 bg-gray-900 px-3 py-2.5 text-sm text-white placeholder:text-gray-600 focus:outline-none focus:ring-2 focus:ring-brand-500/40"
              />
            </div>
            <button
              type="submit"
              className="w-full flex items-center justify-center gap-2 rounded-lg bg-brand-600 hover:bg-brand-500 text-white text-sm font-medium py-2.5 transition-colors"
            >
              View open roles
              <ArrowRight className="w-4 h-4" />
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
